import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import {type loggedInUserQueryType} from "./__graphql-types__/index.ts";

export const CALCULATE_NEXT_URL_USER_QUERY: GqlOperation<
    loggedInUserQueryType["response"],
    loggedInUserQueryType["variables"]
> = gqlOp(gql`
    query loggedInUserQuery {
        user {
            id
            kaid
            canAccessDistrictsHomepage
            isTeacher
            hasUnresolvedInvitations
            isInKhanClassroomDistrict
            preferredKaLocale {
                id
                kaLocale
                status
            }
            userDistrictInfos {
                id
                district {
                    id
                    kaLocale
                }
            }
            homepageUrl
        }
    }
`);
